//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';
import * as Action from "./actions"
//  -- Actions ------------------------
import { logToSentry } from "utils/networkErrorUtils";




export const handleGetClassActiveGameSession = (class_id, user_id, session_id) => async (dispatch) => {
    try {
        const oneGameSyncData = await apis.post('one_game', `/list_game_session`, {
            body: {
                class_id, user_id, session_id
            }
        });
        if (oneGameSyncData && oneGameSyncData.session_id) {
            dispatch(Action.setCurrentGameSession(oneGameSyncData))
        } else {
            dispatch(Action.clearCurrentGameSession())
        }
        return oneGameSyncData
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in operation',
                error,
                module: 'GAME_SESSION',
                operation: 'GET_CLASS_ACTIVE_GAME_SESSION'
            })
        }
    }
};

export const handleCreateGameSession = (session_id, created_by, class_id, game_data, game_config) => async (dispatch) => {
    try {
        const oneGameSyncData = await apis.post('one_game', `/create_game_session`, {
            body: {
                session_id, created_by, class_id, game_data , game_config
            }
        });
        if (oneGameSyncData && oneGameSyncData.session_id) {
            dispatch(Action.setCurrentGameSession(oneGameSyncData))
        } else {
            dispatch(Action.clearCurrentGameSession())
        }
        return oneGameSyncData
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in operation',
                error,
                module: 'GAME_SESSION',
                operation: 'CREATE_GAME_SESSION'
            })
        }
    }
}


export const handleUpdateCurrentGameSessionStatus = (session_id,status) => async (dispatch) => {
    try {
        const oneGameSyncData = await apis.put('one_game', `/update_game_session_status`, {
            body: {
                session_id, status
            }
        });
        if (oneGameSyncData && oneGameSyncData.session_id) {
            dispatch(Action.updateCurrentGameSession(oneGameSyncData))
        }
        return oneGameSyncData
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in operation',
                error,
                module: 'GAME_SESSION',
                operation: 'UPDATE_CURRENT_GAME_SESSION_STATUS'
            })
        }
    }
}
export const handleUpdateCurrentGameSessionUserSeen= (session_id, user_id) => async (dispatch) => {
    try {
        const oneGameSyncData = await apis.put('one_game', `/update_game_session_seen`, {
            body: {
                session_id, user_id
            }
        });
        if (oneGameSyncData && oneGameSyncData.session_id) {
            dispatch(Action.updateCurrentGameSession(oneGameSyncData))
        }
        return oneGameSyncData
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in operation',
                error,
                module: 'GAME_SESSION',
                operation: 'GET_CLASS_ACTIVE_GAME_SESSION'
            })
        }
    }
}


export const handleCheckCurrentGame= (user_id, class_id) => async (dispatch) => {
    try {
        const oneGameSyncData = await apis.post('one_game', `/check_game_session`, {
            body: {
                user_id,
                class_id
            }
        });
        return oneGameSyncData
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in operation',
                error,
                module: 'GAME_SESSION',
                operation: 'GET_CLASS_ACTIVE_GAME_SESSION'
            })
        }
    }
}